import { createAction } from "@ngrx/store";


export const isMobile = createAction(
    '[Layout] Extra small breakpoint reached'
);

export const isNotMobile = createAction(
    '[Layout] Viewport is greater than the extra small breakpoint'
)